import { createSlice } from '@reduxjs/toolkit';

export interface calcFinishedCallbacks {
  name: string;
  callback: () => void;
}

interface CalcBuilderState {
  parentIsLoading: boolean;
  preventSnackbar: boolean;
  onCalculationsFinishedCallbacks: calcFinishedCallbacks[];
}

const BASE_INITIAL_STATE: CalcBuilderState = {
  parentIsLoading: true,
  preventSnackbar: false,
  onCalculationsFinishedCallbacks: [],
};

const slice = createSlice({
  name: 'CalcBuilder',
  initialState: BASE_INITIAL_STATE,
  reducers: {
    addOnCalculationsFinishedCallbacks: (state, action) => {
      const { payload } = action;
      const callbackIndex = state.onCalculationsFinishedCallbacks?.findIndex(
        (cb) => cb.name === payload.name
      );

      if (callbackIndex !== -1) {
        return;
      }
      state.onCalculationsFinishedCallbacks.push(payload);
    },
    removeCalculationsFinishedCallback: (state, action) => {
      const { payload } = action;
      state.onCalculationsFinishedCallbacks =
        state.onCalculationsFinishedCallbacks.filter(
          (cb) => cb.name !== payload
        );
    },
    setParentIsLoading: (state, action) => {
      state.parentIsLoading = action.payload;
    },
    setPreventSnackbar: (state, action) => {
      state.preventSnackbar = action.payload;
    },
    resetCalcBuilderSlice: () => {
      return BASE_INITIAL_STATE;
    },
  },
});

export default slice.reducer;

export const {
  addOnCalculationsFinishedCallbacks,
  removeCalculationsFinishedCallback,
  setParentIsLoading,
  setPreventSnackbar,
  resetCalcBuilderSlice,
} = slice.actions;
